import { bindTypename } from './bindTypename';

export function bindTypenameInList<TItem, TTypename extends string, TItemOut = TItem>(
    items: TItem[] | null | undefined,
    name: TTypename,
    subTransform?: (i: TItem) => TItemOut
): (TItemOut & { __typename: TTypename })[] | null {
    return (
        items?.map(
            item =>
                bindTypename<TItem, TTypename, TItemOut>(item, name, subTransform) as TItemOut & {
                    __typename: TTypename;
                }
        ) || null
    );
}
